export default __webpack_public_path__ + "static/media/Facebook.3e3b0d20.svg";